import { render, staticRenderFns } from "./AccommodationsEdit.vue?vue&type=template&id=14b2cea8&scoped=true&"
import script from "./AccommodationsEdit.vue?vue&type=script&lang=js&"
export * from "./AccommodationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2cea8",
  null
  
)

export default component.exports